// Guarded so it only binds once.
(function () {
  if (window.__freeBookOfferInit) return;
  window.__freeBookOfferInit = true;

  var inFlight = false;

  function offerEls() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-free-book-offer]'));
  }
  function cbOf(o) { return o.querySelector('.free-book-offer__checkbox'); }
  function variantOf(o) { return parseInt(o.getAttribute('data-variant-id'), 10); }
  // A card whose book is already in the cart: kept visible, deselected, shown
  // with an "Added to Cart" indicator, and excluded from selection.
  function isInCart(o) { return o.classList.contains('is-in-cart'); }

  function mainForm() {
    return (
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }
  function qtyInput() {
    var f = mainForm();
    return (f && f.querySelector('[name="quantity"]')) || document.querySelector('[name="quantity"]');
  }
  // How many free books may be picked = quantity of the qualifying product (>=1).
  function capValue() {
    var q = qtyInput();
    var v = q ? parseInt(q.value, 10) : 1;
    return v && v > 0 ? v : 1;
  }

  // Cards the shopper can still pick: those NOT already in the cart.
  function selectable() {
    return offerEls().filter(function (o) { return !isInCart(o); });
  }

  // Keep the number of selected books within the cap (radio-like swap at cap 1).
  function enforceCap(changed) {
    var cap = capValue();
    var checked = selectable().filter(function (o) { return cbOf(o).checked; });
    while (checked.length > cap) {
      var victim;
      if (changed) {
        victim = null;
        for (var i = 0; i < checked.length; i++) {
          if (checked[i] !== changed) { victim = checked[i]; break; }
        }
        if (!victim) victim = checked[0];
      } else {
        victim = checked[checked.length - 1];
      }
      cbOf(victim).checked = false;
      checked = checked.filter(function (o) { return o !== victim; });
    }
  }

  function selectedGiftIds() {
    var seen = {}, ids = [];
    offerEls().forEach(function (o) {
      if (isInCart(o)) return; // already in the cart -> don't re-add
      var cb = cbOf(o), vid = variantOf(o);
      if (cb && cb.checked && vid && !seen[vid]) { seen[vid] = true; ids.push(vid); }
    });
    return ids;
  }

  // Build /cart/add.js line items for the checked offers, split by cart state:
  //   - NOT in cart  -> free gift (carries _free_book => $0 via the auto-discount),
  //                     capped to freeCap (the qualifying product's quantity).
  //   - ALREADY in cart -> a PAID extra copy (no property => full price), uncapped,
  //                     a separate line item from the free one.
  function selectedGiftItems(freeCap) {
    var seen = {}, free = [], paid = [];
    offerEls().forEach(function (o) {
      var cb = cbOf(o), vid = variantOf(o);
      if (!(cb && cb.checked && vid) || seen[vid]) return;
      seen[vid] = true;
      if (isInCart(o)) {
        paid.push({ id: vid, quantity: 1 });
      } else {
        free.push({ id: vid, quantity: 1, properties: { _free_book: 'true' } });
      }
    });
    if (typeof freeCap === 'number' && freeCap >= 0) free = free.slice(0, freeCap);
    return free.concat(paid);
  }

  // Mark a card as already in the cart: keep it visible and DESELECT the free
  // pick, but leave the checkbox ENABLED so the shopper can add another copy at
  // full price. CSS (.is-in-cart) shows the "Added to Cart" label + full price.
  function markInCart(o) {
    o.classList.add('is-in-cart');
    var cb = cbOf(o);
    if (cb) cb.checked = false;
  }

  // Book left the cart -> the card is offerable again: clear the indicator and
  // re-enable the checkbox (selection is (re)applied by ensureSelection).
  function clearInCart(o) {
    if (!o.classList.contains('is-in-cart')) return;
    o.classList.remove('is-in-cart');
    var cb = cbOf(o);
    if (cb) cb.disabled = false;
  }

  // Move in-cart cards to the END of each track so an un-added offer leads
  // (the "next offer is shown" behaviour for multi-book products).
  function reorderTracks() {
    document.querySelectorAll('[data-fbo-track]').forEach(function (track) {
      Array.prototype.slice
        .call(track.querySelectorAll('.free-book-offer.is-in-cart'))
        .forEach(function (o) { track.appendChild(o); });
    });
  }

  // After a book is added and shuffled to the end, snap each carousel back to
  // its first card so the next available offer leads the view (multi-book case).
  function scrollTracksToStart() {
    document.querySelectorAll('[data-fbo-track]').forEach(function (track) {
      track.scrollLeft = 0;
    });
  }

  // If nothing is selected, pre-check the first still-offerable card whose
  // data-preselect is 'true' -- so after a book is added (and moved to the end),
  // the next offer becomes the pre-selected one. Repeat-buyer / owned cards have
  // data-preselect='false' and are never auto-selected here.
  function ensureSelection() {
    var sel = selectable();
    if (sel.some(function (o) { return cbOf(o) && cbOf(o).checked; })) return;
    for (var i = 0; i < sel.length; i++) {
      if (sel[i].getAttribute('data-preselect') === 'true') {
        var cb = cbOf(sel[i]);
        if (cb) cb.checked = true;
        return;
      }
    }
  }

  // Single remaining card fills the width (no peek). The group always stays
  // visible now -- added books remain on the page with their indicator.
  function relayout() {
    document.querySelectorAll('[data-fbo-track]').forEach(function (track) {
      var all = Array.prototype.slice.call(track.querySelectorAll('[data-free-book-offer]'));
      all.forEach(function (o) { o.classList.toggle('is-full', all.length <= 1); });
    });
  }

  // Reflect the cart: mark offers whose book is in it (Added to Cart, moved to
  // the end), clear those that aren't, then (re)apply the default selection.
  // The default selection is applied only on the FIRST sync (page load) and
  // after a GENUINE add -- never on unrelated cart syncs, so a shopper who
  // deliberately unchecks every box is not fought by a re-check (and a book
  // removed in the drawer stays unchecked rather than re-arming itself).
  var everSynced = false;
  function syncFromCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var firstSync = !everSynced;
        everSynced = true;
        var present = {};
        (cart && cart.items ? cart.items : []).forEach(function (i) { present[i.variant_id] = true; });
        var newlyAdded = false;
        offerEls().forEach(function (o) {
          var inCartNow = !!present[variantOf(o)];
          if (inCartNow && !isInCart(o)) { newlyAdded = true; }
          if (inCartNow) { markInCart(o); } else { clearInCart(o); }
        });
        reorderTracks();
        relayout();
        if (firstSync || newlyAdded) { ensureSelection(); }
        enforceCap(null);
        // A book was just added (and moved to the end) -> reset the view to the
        // start so the next available offer is easy to see. Only on a real add,
        // never on unrelated cart syncs (e.g. removing an item elsewhere).
        if (newlyAdded) { scrollTracksToStart(); }
        document.querySelectorAll('[data-fbo-group]').forEach(function (group) {
          try { group.dispatchEvent(new CustomEvent('free-book-offer:selection-settled', { bubbles: true })); } catch (e) {}
        });
      })
      .catch(function () {
        relayout();
        if (!everSynced) { everSynced = true; ensureSelection(); }
        enforceCap(null);
        document.querySelectorAll('[data-fbo-group]').forEach(function (group) {
          try { group.dispatchEvent(new CustomEvent('free-book-offer:selection-settled', { bubbles: true })); } catch (e) {}
        });
      });
  }

  // Re-sync (debounced) whenever the cart changes elsewhere — e.g. the book
  // is removed in the cart drawer, which should make the offer reappear.
  var fbSyncTimer = null;
  var fbSelfSync = false;
  // Suppress observer-driven re-syncs caused by our OWN cart renders (the
  // explicit syncFromCart we run after an add still fires directly).
  function markSelfSync() {
    fbSelfSync = true;
    setTimeout(function () { fbSelfSync = false; }, 600);
  }
  function scheduleSync() {
    if (fbSelfSync || fbSyncTimer) return;
    fbSyncTimer = setTimeout(function () { fbSyncTimer = null; syncFromCart(); }, 150);
  }
  function watchCart() {
    if (typeof window.subscribe === 'function') {
      window.subscribe('cart-update', function (evt) {
        if (evt && evt.source === 'free-book-offer') return; // our own add already synced
        scheduleSync();
      });
    }
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(scheduleSync).observe(drawer, { childList: true, subtree: true });
    }
    // The cart can change in another tab, or while this page sits in the
    // back/forward cache -- no event reaches this page for those. Re-sync when
    // the page becomes visible again so the cards reflect reality before the
    // shopper interacts with them.
    window.addEventListener('pageshow', function (e) { if (e.persisted) scheduleSync(); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') scheduleSync();
    });
  }

  function isMainProductForm(form) {
    return (
      form &&
      form.tagName === 'FORM' &&
      /\/cart\/add/.test(form.getAttribute('action') || '') &&
      form.closest('product-form') &&
      form.querySelector('[name="id"]')
    );
  }

  function postAdd(payload) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw e; }); }
      return r.json();
    });
  }

  function variantQtyInCart(cartJson, variantId) {
    if (!cartJson || !Array.isArray(cartJson.items)) return null;
    return cartJson.items.reduce(function (sum, item) {
      return item.variant_id === variantId ? sum + item.quantity : sum;
    }, 0);
  }

  function setBusy(form, busy) {
    document.querySelectorAll('[data-fbo-group]').forEach(function (g) { g.classList.toggle('is-busy', busy); });
    var btn = form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]');
    if (!btn) return;
    if (busy) {
      if (!btn.hasAttribute('data-fbo-prev-disabled')) {
        btn.setAttribute('data-fbo-prev-disabled', btn.disabled ? 'true' : 'false');
        btn.setAttribute('data-fbo-prev-aria-disabled', btn.hasAttribute('aria-disabled') ? btn.getAttribute('aria-disabled') : '__missing__');
      }
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      var sp = btn.querySelector('.loading__spinner, .loading-overlay__spinner');
      if (sp) sp.classList.remove('hidden');
    } else {
      btn.disabled = btn.getAttribute('data-fbo-prev-disabled') === 'true';
      var prevAriaDisabled = btn.getAttribute('data-fbo-prev-aria-disabled');
      if (prevAriaDisabled === '__missing__') btn.removeAttribute('aria-disabled');
      else btn.setAttribute('aria-disabled', prevAriaDisabled);
      btn.removeAttribute('data-fbo-prev-disabled');
      btn.removeAttribute('data-fbo-prev-aria-disabled');
      // A variant response that lands after this restore corrects availability; if it lands before the restore, this can still overwrite it (normally no worse than today's blind-enable because an accepted submit starts enabled).
      btn.classList.remove('loading');
      var sp2 = btn.querySelector('.loading__spinner, .loading-overlay__spinner');
      if (sp2) sp2.classList.add('hidden');
    }
  }

  // The main product made it into the cart but the book add failed: tell the
  // shopper in the drawer's alert region. The drawer HTML is swapped fresh by
  // refreshCartUI, so this must be written AFTER the render.
  function showGiftError(err) {
    var msg = err && (err.description || err.message);
    var text = msg
      ? 'The storybook could not be added: ' + msg
      : 'The storybook could not be added. Please try again from the product page.';
    // Routed through the shared qcartShowCartError (cart-drawer.js) so this
    // and the other three writers of #CartDrawer-CartErrors share one timer
    // instead of racing; typeof-guarded since script load order across
    // files is not guaranteed.
    if (typeof window.qcartShowCartError === 'function') {
      window.qcartShowCartError(text);
      return;
    }
    var el = document.getElementById('CartDrawer-CartErrors');
    if (!el) return;
    el.textContent = text;
  }

  // Dawn's renderContents swaps #CartDrawer's inner HTML but not the
  // <cart-drawer> host class, so a first add from an EMPTY cart leaves the
  // stale "is-empty" class on the host and CSS keeps the items hidden
  // (subtotal updates but no items show). Re-sync it from the rendered section.
  function fixEmptyState(cart, state) {
    if (!cart || !cart.classList) return;
    try {
      var sec = state && state.sections && state.sections['cart-drawer'];
      if (sec) {
        var fresh = new DOMParser().parseFromString(sec, 'text/html').querySelector('cart-drawer');
        if (fresh) { cart.classList.toggle('is-empty', fresh.classList.contains('is-empty')); return; }
      }
    } catch (e) {}
    cart.classList.remove('is-empty'); // we only render after a successful add
  }

  function refreshCartUI(cart, state) {
    try {
      if (cart && cart.renderContents) {
        markSelfSync();
        cart.renderContents(state);
        fixEmptyState(cart, state);
      } else {
        window.location = '/cart';
        return;
      }
    } catch (err) {
      window.location = '/cart';
      return;
    }
    if (typeof window.publish === 'function') {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (full) { window.publish('cart-update', { source: 'free-book-offer', cartData: full }); })
        .catch(function () {});
    }
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!isMainProductForm(form)) return;

      var idInput = form.querySelector('[name="id"]');
      var qtyFieldEl = form.querySelector('[name="quantity"]');
      var mainId = parseInt(idInput.value, 10);
      var qty = qtyFieldEl ? parseInt(qtyFieldEl.value, 10) || 1 : 1;
      var cap = qty > 0 ? qty : 1;

      // Free gifts (capped to the product quantity) + any paid extras (books
      // already in the cart, added at full price). Nothing opted in -> let the
      // theme add the main product on its own.
      var giftItems = selectedGiftItems(cap);
      if (!giftItems.length) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      if (inFlight) return;
      inFlight = true;

      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var sectionIds =
        cart && cart.getSectionsToRender
          ? cart.getSectionsToRender().map(function (s) { return s.id; })
          : [];

      var mainAdded = false;
      var preQty = null;
      var giftAddError = null;

      setBusy(form, true);

      // Freshness guard: re-check the live cart first so a book that slipped
      // into the cart elsewhere (another tab, back/forward-cache restore) is
      // not re-added as a free gift -- identical line-item properties would
      // merge into one line where only one unit gets the discount. Stale FREE
      // picks are dropped; PAID picks stay (already-in-cart is exactly what
      // makes them paid extras).
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json().then(function (cartJson) {
            var cartQty = variantQtyInCart(cartJson, mainId);
            if (r.ok && cartQty !== null) { preQty = cartQty; }
            return cartJson;
          });
        })
        .catch(function () { return null; })
        .then(function (cartJson) {
          if (cartJson && cartJson.items) {
            var present = {};
            cartJson.items.forEach(function (i) { present[i.variant_id] = true; });
            giftItems = giftItems.filter(function (it) {
              return it.properties ? !present[it.id] : true;
            });
          }

          if (!giftItems.length) {
            // Every selected book turned out to be in the cart already -> add
            // just the main product, with sections so the drawer re-renders.
            return postAdd({
              items: [{ id: mainId, quantity: qty }],
              sections: sectionIds,
              sections_url: window.location.pathname
            }).then(function (state) { mainAdded = true; return state; });
          }

          // Add the main product first (so mainAdded is tracked for error
          // recovery), then the gift line items together with the re-render.
          return postAdd({ items: [{ id: mainId, quantity: qty }] }).then(function () {
            mainAdded = true;
            return postAdd({
              items: giftItems,
              sections: sectionIds,
              sections_url: window.location.pathname
            }).catch(function (err) {
              // Book add failed after the main add succeeded: remember the
              // error to surface after the render, and refetch the sections
              // so the drawer still reflects the main item.
              giftAddError = err || true;
              var q = sectionIds.length ? ('?sections=' + sectionIds.join(',')) : '';
              return fetch(window.location.pathname + q)
                .then(function (r) { return r.json(); })
                .then(function (secs) { return { sections: secs }; });
            });
          });
        })
        .then(function (state) {
          refreshCartUI(cart, state);
          if (giftAddError) { showGiftError(giftAddError); }
          syncFromCart(); // mark the offer(s) now in the cart as Added
        })
        .catch(function () {
          if (mainAdded) {
            window.location = '/cart';
          } else {
            if (preQty === null) { form.submit(); return; }
            return fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) {
                if (!r.ok) return null;
                return r.json();
              })
              .then(function (cartJson) {
                var currentQty = variantQtyInCart(cartJson, mainId);
                if (currentQty !== null && currentQty >= preQty + qty) {
                  window.location = '/cart';
                } else {
                  form.submit();
                }
              })
              .catch(function () { form.submit(); });
          }
        })
        .finally(function () {
          inFlight = false;
          setBusy(form, false);
        });
    },
    true
  );

  function wire() {
    offerEls().forEach(function (o) {
      var cb = cbOf(o);
      if (cb && !cb.getAttribute('data-fb-wired')) {
        cb.setAttribute('data-fb-wired', '1');
        cb.addEventListener('change', function () { enforceCap(o); });
      }
    });
    var q = qtyInput();
    if (q && !q.getAttribute('data-fb-wired')) {
      q.setAttribute('data-fb-wired', '1');
      q.addEventListener('change', function () { enforceCap(null); });
      q.addEventListener('input', function () { enforceCap(null); });
    }
  }

  function init() {
    wire();
    watchCart();
    relayout();
    syncFromCart();
  }

  // Tiny API so other components (e.g. the sticky Add-to-Cart sheet) can read
  // the selected free book(s) and refresh the cart after their own add.
  window.FreeBookOffer = {
    selectedGiftIds: function () { return selectedGiftIds(); },
    selectedGiftItems: function (freeCap) { return selectedGiftItems(freeCap); },
    syncFromCart: function () { return syncFromCart(); },
    fixEmptyState: function (cart, state) { return fixEmptyState(cart, state); },
    markSelfSync: function () { return markSelfSync(); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
